import selectors from '../../../../rootSelectors';
import { activateReadyForNextScreen } from '../../../../common/questions/questionsActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import { VOCAB } from '../../../../constants/measure';
import {
    blockScreen,
    greyOutScreen,
    unblockScreen,
} from '../../../../common/screen/screenActions';
import { goToCountdown } from '../../../../common/navigation/navigationActions';
import { narrateReset, narrateStart } from '../../../../common/audio/audioActions';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';
import { autoplayScript } from '../../vocabTQVMActions';
import { startQuestionTimeTracking } from '../../../../common/timeTracking/timeTrackingActions';

export const narratePracticeScreen = (stimulusAudio) => async (dispatch, getState) => {
    const state = getState();
    const language = selectors.getCurrentLanguage(state);

    dispatch(blockScreen());
    dispatch(narrateStart());
    await dispatch(playAvatarAudio([
        VOCAB_AUDIO_INSTRUCTIONS[language].vocabTQVMPracticeInstructionStart
    ]));
    await dispatch(autoplayScript(stimulusAudio));
    dispatch(narrateReset());
    dispatch(unblockScreen());
    dispatch(startQuestionTimeTracking());
};

export const onNextPracticeButtonClick = () => (dispatch, getState) => {
    const state = getState();
    const language = selectors.getCurrentLanguage(state);

    dispatch(blockScreen());
    dispatch(greyOutScreen());

    if (!selectors.getQuestionsIsReadyForNextScreen(state)) {
        return dispatch(playAvatarAudio([
            VOCAB_AUDIO_INSTRUCTIONS[language].vocabTQVMPracticeReadyInstruction
        ])).then(() => {
            dispatch(setAvatarInstructions(VOCAB_AUDIO_INSTRUCTIONS[language].clickOk));
            dispatch(activateReadyForNextScreen());

            return dispatch(unblockScreen());
        });
    }

    return dispatch(goToCountdown(VOCAB.ASSESSMENT, VOCAB.TQVM));
};
